import { AuthService } from './auth.service';
import { provideAuth, AuthHttp, AuthConfig } from 'angular2-jwt/angular2-jwt';
import { Http, RequestOptions } from '@angular/http';
import { ArcService } from './arc.service';
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
import { TagService } from './tag.service'
import { RuntimeService } from './runtime.service'
import { DbRecordService } from './db-record.service'

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { routing } from './app.routing';

import { ProjectDbRecordsComponent } from './project-db-records/project-db-records.component';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component'
import { ProjectBoxComponent } from './project-box/project-box.component';

import { AdminService } from './admin.service';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UsersDashboardComponent } from './users-dashboard/users-dashboard.component';
import { LoginBoxComponent } from './login-box/login-box.component';
import { AdminPageComponent } from './admin-page/admin-page.component'
import { DbRecordBoxComponent } from './db-record-box/db-record-box.component';

import { TagSortComponent } from './tag-sort/tag-sort.component';
import { TagButtonComponent } from './tag-button/tag-button.component';
import { TagPageComponent } from './tag-page/tag-page.component';
import { TagRatingComponent } from './tag-rating/tag-rating.component';
import { PagesBoxComponent } from './pages-box/pages-box.component';
import { RatingBoxComponent } from './rating-box/rating-box.component';
import { RatingSummaryComponent } from './rating-summary/rating-summary.component';
import { FilterInputComponent } from './filter-input/filter-input.component';
import { TagFilterComponent } from './tag-filter/tag-filter.component';
import { NoteBoxComponent } from './note-box/note-box.component';
import { UploadBoxComponent } from './upload-box/upload-box.component';
import { EditProjectUsersBoxComponent } from './edit-project-users-box/edit-project-users-box.component';
import { ProjectDbRecordsStatsComponent } from './project-db-records-stats/project-db-records-stats.component';

import { PageService } from './page.service';
import { RatingService } from './rating.service';
import { FilterService } from './filter.service';
import { SortService } from './sort.service';
import { CriterionService } from './criterion.service';
import { FileService } from './file.service';
import { NoteService } from './note.service';
import { UsersService } from './users.service';
import { RTagGroupService } from './r-tag-group.service'
import { RTagGroupComponent } from './r-tag-group/r-tag-group.component';
import { CrossrefBoxComponent } from './crossref-box/crossref-box.component';
import { CrossrefRecordBoxComponent } from './crossref-record-box/crossref-record-box.component';
import { CrossrefService } from './crossref.service';
import { ExcludeSourcesComponent } from './exclude-sources/exclude-sources.component';
import { RatingTagFilterComponent } from './rating-tag-filter/rating-tag-filter.component';


export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
    tokenGetter: (() => localStorage.getItem('id_token')),
    globalHeaders: [{ 'Content-Type': 'application/json' }],
  }), http, options);
}


@NgModule({
  declarations: [
    AppComponent,
    ProjectDbRecordsComponent,
    ProjectDashboardComponent,
    ProjectBoxComponent,
    ProjectDbRecordsStatsComponent,
    MainMenuComponent,
    AdminDashboardComponent,
    UsersDashboardComponent,
    LoginBoxComponent,
    AdminPageComponent,
    DbRecordBoxComponent,
    TagSortComponent,
    PagesBoxComponent,
    TagPageComponent,
    TagRatingComponent,
    FilterInputComponent,
    TagFilterComponent,
    TagButtonComponent,
    NoteBoxComponent,
    UploadBoxComponent,
    RatingBoxComponent,
    RatingSummaryComponent,
    EditProjectUsersBoxComponent,
    RTagGroupComponent,
    CrossrefBoxComponent,
    CrossrefRecordBoxComponent,
    ExcludeSourcesComponent,
    RatingTagFilterComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    routing
  ],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    AuthService,
    ArcService,
    TagService,
    ProjectService,
    UtilsService,
    AdminService,
    RuntimeService,
    DbRecordService,
    PageService,
    RatingService,
    FilterService,
    SortService,
    CriterionService,
    FileService,
    NoteService,
    UsersService,
    CrossrefService,
    RTagGroupService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/app.module.ts